import Model from 'src/storage/base';

class SettingModel extends Model {
  id = 'settings';
  persistent = false;
  defaultState = () => ({
    avatar: null,
    treatments: [this.defaultTreatments(), this.defaultTreatments(), this.defaultTreatments()]
  });
  defaultTreatments = () => ({
    name: null,
    fee: null
  });
  apiConfig = {
    updatePatient: {
      url: 'profile/update/patient',
      validation: {
        firstName: 'firstName',
        lastName: 'lastName',
        phoneNumber: 'phoneNumber',
        email: 'emailAddress',
        avatar: 'string'
      },
      cancellable: true
    },
    updateDoctor: {
      url: 'profile/update/doctor',
      validation: {
        firstName: 'firstName',
        lastName: 'lastName',
        phoneNumber: 'phoneNumber',
        email: 'email',
        avatar: 'avatar',
        specialist: 'specialist',
        cityAddress: 'cityAddress',
        countryAddress: 'countryAddress',
        description: 'description',
        school: 'school',
        hospitalAffiliations: 'hospitalAffiliations',
        residency: 'residency',
        training: 'number',
        treatments: 'array',
        address: 'address'
      },
      cancellable: true
    },
    updateCertificate: {
      url: 'profile/set/certificateFile',
      validation: {
        files: 'array'
      },
      cancellable: true
    },
    updateAvatar: {
      url: 'profile/set/avatar',
      validation: {
        files: 'array'
      },
      cancellable: true
    },
    change_pw: {
      url: 'profile/password/change',
      validation: {
        password: 'password',
        password1: 'password',
        password2: 'password'
      },
      cancellable: true
    }
  };

  _events = {
    profile: 'handleProfile'
  };

  handleProfile = (nextProfile) => {
    const { password, ...profile } = nextProfile;
    void password;
    this.setState({ ...profile, user: profile });
  };

  handleChangeProfile = (key, value) => {
    if (!this.state.changed) this.setStateSilent({ changed: true });
    this.resetApiState('updatePatient');
    this.resetApiState('updateDoctor');
    this.handleChange(key, value);
  };

  handleChangeAvatar = (data) => {
    console.log('handleChangeAvatar', data);
    this.setStateSilent({ changed: true });
    this.handleChange('avatarFile', data);
    if (!data) this.handleChange('avatar', '');
  };

  handleChangeCertificate = (data) => {
    console.log('handleChangeCertificate', data);
    this.setStateSilent({ changed: true });
    this.handleChange('certificateFileInput', data);
    if (!data) this.handleChange('certificateFile', '');
  };

  savePersonal = () => {
    let req = {
      firstName: this.input('firstName'),
      lastName: this.input('lastName'),
      email: this.input('email'),
      isDoctor: true,
      phoneNumber: this.input('phoneNumber'),
      avatar: this.input('avatar') || ''
    };
    if (this.state.avatarFile) req.files = [this.state.avatarFile.file];
    this.api('updatePatient', req, (error, data, success) => {
      if (success) {
        this.emit('profile', data);
        this.handleChange('avatarFile', '');
        this.resetPersonal();
      }
    });
  };

  savePersonalDoctor() {
    const id = 'updateDoctor';
    const ruleIn = { ...this.getApiConfig(id) }.validation;
    const req = {
      avatar: this.input('avatar') || '',
      certificateFile: this.input('certificateFile') || ''
    };
    for (let k in ruleIn) {
      req[k] = this.input(k);
    }
    req.treatments = req.treatments
      .filter((treatment) => treatment.name)
      .map((treatment) => ({
        name: treatment.name,
        fee: parseFloat(treatment.fee.toString().replace('$', '')) || 0
      }));
    this.api(id, req, (error, data, success) => {
      if (success) {
        this.input('avatarFile') &&
          this.api(
            'updateAvatar',
            {
              files: [this.input('avatarFile')]
            },
            (e, d) => {
              data.avatar = d?.uri;
              this.emit('profile', data);
              this.handleChange('avatarFile', '');
            }
          );
        this.input('certificateFileInput') &&
          this.api(
            'updateCertificate',
            {
              files: [this.input('certificateFileInput')]
            },
            (e, d) => {
              data.certificateFile = d?.uri;
              this.emit('profile', data);
              this.handleChange('certificateFileInput', '');
            }
          );
        this.emit('profile', data);
        this.resetPersonal();
      }
    });
  }

  resetPersonal = () => {
    let user = this.getUser() || {};
    this.resetApiState('updatePatient');
    this.resetApiState('updateDoctor');
    this.setState({
      firstName: user.firstName,
      lastName: user.lastName,
      avatar: user.avatar,
      email: user.email,
      phoneNumber: user.phoneNumber,
      changed: false
    });
  };

  handleChangePw = (key, value) => {
    if (!this.state.changed) this.setStateSilent({ changed: true });
    this.resetApiState('change_pw');
    this.handleChange(key, value);
  };

  savePw = () => {
    let req = {
      password: this.state.password,
      password1: this.state.password1,
      password2: this.state.password2
    };
    this.api('change_pw', req, (error, data, success) => {
      if (success) {
        model.emit('logout');
      }
    });
  };

  resetPwState = () => {
    this.setState({
      changed: false,
      password: '',
      password1: '',
      password2: ''
    });
  };

  addTreatmentMore = () => {
    const { handleChange } = model;
    const treatments = model.input('treatments');
    treatments.push(model.defaultTreatments());
    handleChange('treatments', [...treatments]);
  };

  delTreatmentMore = (delIds) => {
    const { handleChange } = model;
    const treatments = model.input('treatments');
    handleChange('treatments', [...treatments.filter((item, i) => delIds.indexOf(i) === -1)]);
  };
}

const model = new SettingModel();
export default model;
